import React from 'react';

const Subheading = ({ 
  height = '48px', 
  width = '48px', 
  color = '#335262', 
  secondaryColor = '#B3B3B3' 
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>subheading</title>
    <g>
      <path d="M9,41v-3l5.06191-0.47739C14.9517,37.45535,15,37.20187,15,36.25V10H6.23128 c-0.70097,0-0.88979,0.06725-1.01653,0.69838L4,15H1V6h33v9h-3l-1.21216-4.30162C29.6611,10.06725,29.46969,10,28.77131,10H20v26.25 c0,0.88979-0.01378,1.14328,0.93809,1.20535L26,38v3H9z" fill={color}/>
      <path d="M31.58333,41v-1.59413l2.98752-0.20311C34.97706,39.17207,35,39.05634,35,38.6218V22h-4 c-0.32001,0-0.47807,0.09008-0.53593,0.3782L30,25h-2v-5h17v5h-2l-0.4224-2.6218C42.51974,22.09008,42.31882,22,42,22h-4v16.6218 c0,0.40621,0.06427,0.52193,0.49882,0.55027l3.19062,0.23381V41H31.58333z" fill={secondaryColor}/>
    </g>
  </svg>
);

export default Subheading;
